import {
  collection,
  addDoc,

} from "firebase/firestore";
import {  db } from "../providers/database";


import { collectionNames } from "./dictionary/collectionNames";


const applicationTrackerRef = collection(
  db,
  collectionNames.applicationTracker,
);

// Create a new entry for ApplicationTracker
export async function createNewEntryForApplicationTracker(
  data: any,
) {
  const docId= await addDoc(applicationTrackerRef, {
    ...data,
  });
  return docId.id;
}
